import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Treeable} from '../treeable/shared/treeable.model';
import {Site} from '../treeable/shared/site.model';

/**
 * Manages the state of objects in dotcms-js so compoents can Observe changes and reload as needed
 */

export class SiteBrowserState {

    currentFolder: Observable<string>;
    currentSetingsUpdated: Observable<boolean>;
    currentSite: Observable<Site>;
    currentTreeable: Observable<Treeable>;
    currentURI: Observable<string>;
    private currentSiteSubject: BehaviorSubject<Site> = new BehaviorSubject<Site>(null);
    private currentFolderSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private currentURISubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private currentTreeableSubject: BehaviorSubject<Treeable> = new BehaviorSubject<Treeable>(null);
    private currentSettingsUpdatedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    constructor() {
        this.currentFolder = this.currentFolderSubject.asObservable();
        this.currentSetingsUpdated = this.currentSettingsUpdatedSubject.asObservable();
        this.currentSite = this.currentSiteSubject.asObservable();
        this.currentTreeable = this.currentTreeableSubject.asObservable();
        this.currentURI = this.currentURISubject.asObservable();
    }

    changeSite(siteName: Site): void {
        this.currentSiteSubject.next(siteName);
    }

    getSelectedSite(): Site {
        return <Site> this.currentSiteSubject.getValue();
    }

    changeFolder(folderName: string): void {
        this.currentFolderSubject.next(folderName);
    }

    getSelectedFolder(): string {
        return <string> this.currentFolderSubject.getValue();
    }

    changeURI(uri: string): void {
        this.currentURISubject.next(uri);
    }
    getURI(): string {
        return <string> this.currentURISubject.getValue();
    }

    changeTreeable(treeable: Treeable): void {
        this.currentTreeableSubject.next(treeable);
    }

    getSelectedTreeable(): Treeable {
        return <Treeable> this.currentTreeableSubject.getValue();
    }

    changeSettingsUpdated(settingsUpdated: boolean): void {
        this.currentSettingsUpdatedSubject.next(settingsUpdated);
    }

    getSettingsUpdated(): boolean {
        return <boolean> this.currentSettingsUpdatedSubject.getValue();
    }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
